/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PhysicalCountDiscrepancyDto = {
    id: number;
    productCode: string;
    productUniqueCode?: string;
    productName?: string;
    expectedQty: number;
    actualQty: number;
    discrepancyType: PhysicalCountDiscrepancyDto.discrepancyType;
    /**
     * For scanned_not_available: RESERVED, PARTIAL_PAYMENT, or SOLD
     */
    availabilityStatus?: string;
    /**
     * Set when this missing line was written off in warehouse inventory
     */
    writtenOffAt?: string;
    /**
     * User who performed the write-off
     */
    writtenOffBy?: string;
};
export namespace PhysicalCountDiscrepancyDto {
    export enum discrepancyType {
        MISSING = 'missing',
        EXCESS = 'excess',
        SCANNED_NOT_AVAILABLE = 'scanned_not_available',
    }
}

